var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-header"},[_c('BackButton',{on:{"click":function($event){return _vm.$emit('back')}}}),_c('h4',[_vm._v(_vm._s(_vm.chatName))]),(!_vm.isGroup && !_vm.talking)?_c('CallButton',{attrs:{"id":_vm.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }